export default __webpack_public_path__ + "static/media/Call 2.e998984a.svg";